import InTheNews from './InTheNews';

export default InTheNews;
